export default "__VITE_PUBLIC_ASSET__71a25ef8__"